import Checkbox from "@/components/Checkbox";
import Radio from "@/components/Radio";
import { ApplicationQuestion, Option } from "@/pages/_layouts/jobs/types";
import { sortBy } from "lodash";

interface QuestionsDetailsReadOnlyProps {
  questions: ApplicationQuestion[];
}

export function QuestionsDetailsReadOnly({ questions }: QuestionsDetailsReadOnlyProps) {
  const renderInput = (question: ApplicationQuestion, option: Option) => {
    const { questionType } = question;
    switch (questionType) {
      case "multi-select":
        return (
          <Checkbox
            label=""
            checked={false}
            name={`multiple_select_option_${option.id}`}
            onChange={() => {}}
            disabled={true}
          />
        );

      case "single-select":
        return (
          <Radio
            label=""
            checked={false}
            name={`single_select_option_${option.id}`}
            disabled={true}
            onChange={() => {}}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="my-2 ml-4">
      <ol className="list-decimal space-y-6">
        {sortBy(questions, "position").map((question) => (
          <li key={question.id} className="text-title-medium">
            <div>{question.content}</div>
            <ul className="list-none -ml-1">
              {sortBy(question.options, "position").map((option, optIndex) => (
                <div key={optIndex} className="flex items-center my-4 z-0">
                  {renderInput(question, option)}
                  <span className="text-body-large">{option.content}</span>
                </div>
              ))}
            </ul>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default QuestionsDetailsReadOnly;
